import { render } from "./CarouselTopbar.vue?vue&type=template&id=2275a3f4"
import script from "./CarouselTopbar.vue?vue&type=script&lang=js"
export * from "./CarouselTopbar.vue?vue&type=script&lang=js"

import "./CarouselTopbar.vue?vue&type=style&index=0&id=2275a3f4&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__